import React from "react";
import Table from "../../ui/Table/Table";
import "./AggregatorTable.scss";

import Checkbox from "../../ui/Checkox/Checkbox";

import classnames from "classnames";

import HasImageIcon from "!svg-inline-loader!./has-image.svg";

import SvgInline from "../../ui/SvgInline.js";

import useSort from "../../hooks/useSort";

const AggregatorTable = ({ selected, onCheckChange, items }) => {
  const { sortBy, sortOrder, onSortChange } = useSort("title", "asc");

  const columns = [
    {
      title: "Есть анонс",
      accessor: "has_teaser",
      className: "has-teaser",
      dataClassName: "has-teaser",
      renderHeaderCell: ({}) => {
        return (
          <span className="aggregator-table__with-check">
            <span className="aggregator-table__has-image-title">
              Есть анонс
            </span>
          </span>
        );
      },
      renderDataCell: ({ data }) => {
        return (
          <span className="aggregator-table__with-check">
            <Checkbox
              id={`aggregator-${data.id}`}
              checked={selected.indexOf(data.id) != -1}
              onChange={e => {
                onCheckChange({ id: data.id, checked: e.target.checked });
              }}
            />
            <i
              className={classnames("aggregator-table__dot", {
                green: data.has_teaser,
                gray: !data.has_teaser
              })}
            />
          </span>
        );
      }
    },
    {
      title: "Заголовок",
      accessor: "title",
      className: "title table__border-right",
      dataClassName: "title table__border-right",
      renderDataCell: ({ data }) => {
        return (
          <a href={data.link} target="_blank">
            {data.title}
          </a>
        );
      }
    },
    {
      title: "Наличие изображения",
      accessor: "is_image_valid",
      className: "has-image",
      dataClassName: "has-image",
      renderDataCell: ({ data }) => {
        return (
          <SvgInline
            src={HasImageIcon}
            className={classnames("aggregator-table__has-image-icon", {
              green: data.is_image_valid
            })}
          />
        );
      }
    }
  ];

  return (
    <div className="aggregator-table">
      <Table
        columns={columns}
        data={items}
        sortBy={sortBy}
        sortOrder={sortOrder}
        onSortChange={onSortChange}
      />
    </div>
  );
};

AggregatorTable.defaultProps = {
  selected: [],
  items: []
};

export default AggregatorTable;
